export default __webpack_public_path__ + "static/media/GBA BMM.ee7d965a.png";